// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
// Pinned to bd8cb85bd4bad964fe6918f79665bb40c3a8efef.
import { MaterialSymbol, type MaterialIconProps } from './material-symbol';
const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m438-441-60-60q-10.64-11-24.82-11T328-501q-11 11-11 25.67 0 14.66 11 25.33l84 85q10.91 11 25.45 11Q452-354 463-365l170-170q11-11 11-25t-11-25q-11-11-25.67-11-14.66 0-25.33 11L438-441Zm42 341q-6 0-12-.5t-11-2.5q-131-43-210-159t-79-253v-180q0-22.69 12.5-40.85Q193-754 214-762l240-92q13-5 26-5t26 5l240 92q21 8 33.5 26.15Q792-717.69 792-695v180q0 137-79 253T503-103q-5 2-11 2.5t-12 .5Zm0-71q104-32.25 172-129t68-215v-180l-240-92-240 92v180q0 118.25 68 215t172 129Zm0-308Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m438-452-56-56q-12-12-28-12t-28 12q-12 12-12 28.5t12 28.5l84 85q12 12 28 12t28-12l170-170q12-12 12-28.5T636-593q-12-12-28.5-12T579-593L438-452Zm42 368q-7 0-13-1t-12-3q-135-45-215-166.5T160-516v-189q0-25 14.5-45t37.5-29l240-90q14-5 28-5t28 5l240 90q23 9 37.5 29t14.5 45v189q0 140-80 261.5T505-88q-6 2-12 3t-13 1Zm0-80q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-316Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m438-441-60-60q-11-11-25-11t-25 11q-11 11-11 25.5t11 25.5l84 85q11 11 25.5 11t25.5-11l170-170q11-11 11-25t-11-25q-11-11-25.5-11T582-585L438-441Zm42 341q-6 0-12-.5t-11-2.5q-131-43-210-159t-79-253v-180q0-23 12.5-41t33.5-26l240-92q13-5 26-5t26 5l240 92q21 8 33.5 26t12.5 41v180q0 137-79 253T503-103q-5 2-11 2.5t-12 .5Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "m438-452-56-56q-12-12-28-12t-28 12q-12 12-12 28.5t12 28.5l84 85q12 12 28 12t28-12l170-170q12-12 12-28.5T636-593q-12-12-28.5-12T579-593L438-452Zm42 368q-7 0-13-1t-12-3q-135-45-215-166.5T160-516v-189q0-25 14.5-45t37.5-29l240-90q14-5 28-5t28 5l240 90q23 9 37.5 29t14.5 45v189q0 140-80 261.5T505-88q-6 2-12 3t-13 1Z"
    ]
  }
} as const;
export function VerifiedUserIcon(props: MaterialIconProps) { return <MaterialSymbol {...props} symbol="verified_user" artwork={artwork} />; }
